/* deviceConstants.js */

"use strict";
const CustomFieldsCriticalAdvisory = require("./column_renderers/custom_fields_critical_advisory/CustomFieldsCriticalAdvisoryComponent");
const CustomFieldsHighAdvisory = require("./column_renderers/custom_fields_high_advisory/CustomFieldsHighAdvisoryComponent");
const CustomFieldsMediumAdvisory = require("./column_renderers/custom_fields_medium_advisory/CustomFieldsMediumAdvisoryComponent");
const CustomFieldsEox = require("./column_renderers/custom_fields_eox/CustomFieldsEoxComponent");
const CustomFieldsSnContractNo = require("./column_renderers/custom_fields_sn_contract_no/CustomFieldsSnContractNoComponent");
const CustomFieldsSnContractEndDate = require("./column_renderers/custom_fields_sn_contract_end_date/CustomFieldsSnContractEndDateComponent");
const CustomFieldsColumn = require("./column_renderers/custom_fields/CustomFieldsComponent");

const DEVICE_CAPTURE_STATUSES = {
    UNKNOWN: {
        name: "UNKNOWN",
        title: "Unknown",
        icon: "common.unknown",
    },
    ERROR: {
        name: "ERROR",
        title: "Error",
        icon: "common.error",
    },
    PENDING: {
        name: "PENDING",
        title: "Pending",
        icon: "common.pending",
    },
    QUEUED: {
        name: "QUEUED",
        title: "Queued",
        icon: "common.arrow",
    },
    RUNNING: {
        name: "RUNNING",
        title: "Running",
        icon: "common.loading",
    },
    CHANGED: {
        name: "CHANGED",
        title: "Changed",
        icon: "configdrift.changed",
    },
    UNCHANGED: {
        name: "UNCHANGED",
        title: "Unchanged",
        icon: "configdrift.same",
    },
};

const DEVICE_DISCOVERY_STATUSES = {
    UNKNOWN: {
        name: "UNKNOWN",
        title: "Unknown",
        icon: "common.unknown",
    },
    UNREACHABLE: {
        name: "UNREACHABLE",
        title: "Unreachable",
        icon: "common.error",
    },
    ERROR: {
        name: "ERROR",
        title: "Error",
        icon: "common.error",
    },
    PENDING: {
        name: "PENDING",
        title: "Pending",
        icon: "common.pending",
    },
    QUEUED: {
        name: "QUEUED",
        title: "Queued",
        icon: "common.arrow",
    },
    RUNNING: {
        name: "RUNNING",
        title: "Running",
        icon: "common.loading",
    },
    DISCOVERED: {
        name: "DISCOVERED",
        title: "Discovered",
        icon: "devicemanager.discovered",
    },
};

const AUDIT_STATUSES = {
    ERROR: {
        name: "ERROR",
        title: "Error",
        icon: "common.error",
    },
    PENDING: {
        name: "PENDING",
        title: "Pending",
        icon: "common.pending",
    },
    QUEUED: {
        name: "QUEUED",
        title: "Queued",
        icon: "common.arrow",
    },
    RUNNING: {
        name: "RUNNING",
        title: "Running",
        icon: "common.loading",
    },
    PASSED: {
        name: "PASSED",
        title: "Passed",
        icon: "configdrift.audit_policy_passed",
    },
    FAILED: {
        name: "FAILED",
        title: "Failed",
        icon: "configdrift.audit_policy_failed",
    },
    SKIPPED: {
        name: "SKIPPED",
        title: "Skipped",
        icon: "configdrift.audit_policy_skipped",
    },
    UNKNOWN: {
        name: "UNKNOWN",
        title: "Unknown",
        icon: "common.unknown",
    },
};

const DEVICE_CUSTOM_FIELDS = [
    {
        id: "2abc8e82-4631-4fa1-ab66-d414bb4e8e05",
        columnRenderer: CustomFieldsCriticalAdvisory,
        type: 2,
    },
    {
        id: "9ed3ecea-82a4-4141-8d12-f41ec7e04367",
        columnRenderer: CustomFieldsHighAdvisory,
        type: 2,
    },
    {
        id: "8c467f86-c54c-450a-a2b8-c4f57a78b82d",
        columnRenderer: CustomFieldsMediumAdvisory,
        type: 2,
    },
    {
        id: "118d6b5c-1d81-4aa3-a2d8-ad50585ff79b",
        columnRenderer: CustomFieldsEox,
        type: 1,
    },
    {
        id: "092f60e9-d47f-469e-abbf-004781107833",
        columnRenderer: CustomFieldsSnContractNo,
        type: 1,
    },
    {
        id: "0c6644ce-a700-476a-82f9-16e4821ed430",
        columnRenderer: CustomFieldsSnContractEndDate,
        type: 1,
    },
    {
        id: "43236483-c177-42f1-aed5-b972ebe23eb8",
        columnRenderer: CustomFieldsColumn,
        type: 1,
    },
];

const DEVICE_MANAGEMENT_STATES = {
    MANAGED: {
        name: "MANAGED",
        title: "Managed",
    },
    UNMANAGED: {
        name: "UNMANAGED",
        title: "Unmanaged",
    },
    INVENTORY_ONLY: {
        name: "INVENTORY_ONLY",
        title: "Inventory Only",
    },
};

const DISCOVERY_LEVELS = {
    1: {
        name: "1",
        title: "1 - Basic",
    },
    2: {
        name: "2",
        title: "2 - Port",
    },
    3: {
        name: "3",
        title: "3 - Neighbor",
    },
};

const LICENSE_STATUS = {
    true: {
        name: true,
        title: "Yes",
    },
    false: {
        name: false,
        title: "No",
    },
};

const DEVICE_ENVIRONMENTS = {
    PRODUCTION: {
        name: "PRODUCTION",
        title: "Production",
    },
    TEST: {
        name: "TEST",
        title: "Test",
    },
    "PRODUCTION-TEST": {
        name: "PRODUCTION-TEST",
        title: "Production/Test",
    },
};

const ACCESS_STATUS = {
    UNKNOWN: {name: "UNKNOWN", title: "Unknown"},
    OK: {name: "OK", title: "OK"},
    UNREACHABLE: {name: "UNREACHABLE", title: "Unreachable"},
    INVALID_CREDENTIALS: {name: "INVALID_CREDENTIALS", title: "Invalid Credentials"},
    UNDISCOVERABLE: {name: "UNDISCOVERABLE", title: "Undiscoverable"},
};

const SOLUTION_DEFAULT_SHOWN_COLUMNS = {
    device_manager: [
        "detectedTypeBase",
        "name",
        "ip",
        "discoveryStatus",
        "detectedVendor",
        "detectedHostName",
        "detectedPlatform",
        "detectedSerialNumber",
        "detectedSku",
        "lastSuccessfulBackupOn",
        "lastActivityOn",
        "lastActivityType",
        "lastActivityError",
    ],
    config_drift: [
        "detectedTypeBase",
        "name",
        "ip",
        "latestHaveIChanged",
        "detectedVendor",
        "detectedHostName",
        "detectedPlatform",
        "detectedSerialNumber",
        "detectedSku",
        "auditStatus",
        "auditCriticalViolationCount",
        "auditMajorViolationCount",
        "auditViolationCount",
        "lastAuditPolicy",
        "auditedOn",
        "lastActivityOn",
        "lastActivityType",
        "lastActivityError",
    ],
    os_manager: [
        "detectedTypeBase",
        "name",
        "ip",
        "detectedVendor",
        "detectedHostName",
        "detectedPlatform",
        "detectedSerialNumber",
        "detectedSku",
        "osUpgradePlanName",
        "osUpgradeStatus",
        "osUpgradedOn",
        "osUpgradeError",
        "lastActivityOn",
        "lastActivityType",
        "lastActivityError",
    ],
    data_explorer: [
        "detectedTypeBase",
        "name",
        "ip",
        "detectedVendor",
        "detectedHostName",
        "detectedPlatform",
        "detectedSerialNumber",
        "detectedSku",
        "lastActivityOn",
        "lastActivityType",
        "lastActivityError",
    ],
};

const SOLUTION_DEFAULT_SHOWN_COLUMNS_IOT = {
    device_manager: [
        "detectedTypeBase",
        "name",
        "offlineDiscoveryStatus",
        "platformName",
        "manufacturer",
        "deviceType",
        "model",
        "macAddresses",
        "osName",
        "osReleaseName",
        "osVersion",
        "machineArchitecture",
        "serialNumber",
        "lastCmdbSyncOn",
    ],
    os_manager: [
        "detectedTypeBase",
        "name",
        "platformName",
        "manufacturer",
        "deviceType",
        "model",
        "macAddresses",
        "osName",
        "osReleaseName",
        "osVersion",
        "machineArchitecture",
        "serialNumber",
        "lastUpgradePlan",
        "offlineUpgradeStatus",
        "offlineUpgradedOn",
        "lastCmdbSyncOn",
    ],
    data_explorer: [
        "detectedTypeBase",
        "name",
        "platformName",
        "manufacturer",
        "deviceType",
        "model",
        "macAddresses",
        "osName",
        "osReleaseName",
        "osVersion",
        "machineArchitecture",
        "serialNumber",
        "lastCmdbSyncOn",
    ],
};

const LICENSE_RESTRICTED_COLUMNS = {
    CDA: [
        "latestHaveIChangedLastChecked",
        "latestHaveIChanged",
        "capturedBy",
        "auditCriticalViolationCount",
        "auditMajorViolationCount",
        "auditMinorViolationCount",
        "auditInfoViolationCount",
        "auditViolationCount",
        "auditedOn",
        "auditedBy",
        "auditStatus",
        "lastAuditPolicy",
    ],
    OSM: [
        "lastUpgradePlan",
        "upgradeUploadedOn",
        "upgradeUploadedBy",
        "offlineUpgradedOn",
        "offlineUpgradedBy",
        "offlineUpgradeStatus",
        "offlineUpgradeError",
        "offlineUpgradeUpdate",
        "fileServerName",
        "osUpgradeStatus",
        "osUpgradedBy",
        "osUpgradedOn",
        "osUpgradeError",
        "osUpgradePlanId",
        "osUpgradePlanName",
        "osUpgradePlanAction",
    ],
    TAI: [
        "exposureStatus",
        "exposureDisplayStatus",
        "exposureEvaluatedOn",
        "exposureExposedCount",
        "exposureExposedCriticalCount",
        "exposureExposedHighCount",
        "exposureExposedMediumCount",
        "exposureExposedLowCount",
        "exposureExposedInformationalCount",
        "exposureExposedUnratedCount",
        "exposurePotentialCount",
        "exposurePotentialCriticalCount",
        "exposurePotentialHighCount",
        "exposurePotentialMediumCount",
        "exposurePotentialLowCount",
        "exposurePotentialInformationalCount",
        "exposurePotentialUnratedCount",
        "exposureInconclusiveCount",
        "exposureInconclusiveCriticalCount",
        "exposureInconclusiveHighCount",
        "exposureInconclusiveMediumCount",
        "exposureInconclusiveLowCount",
        "exposureInconclusiveInformationalCount",
        "exposureInconclusiveUnratedCount",
        "exposureNotAffectedCount",
    ],
};

const EXPOSURE_DISPLAY_STATUSES = {
    UNKNOWN: {name: "UNKNOWN", title: "Unevaluated"},
    QUEUED: {name: "QUEUED", title: "Queued"},
    RUNNING: {name: "RUNNING", title: "Running"},
    CURRENT: {name: "CURRENT", title: "Current"},
    STALE: {name: "STALE", title: "Stale"},
    ERROR: {name: "ERROR", title: "Failed"},
    NOT_SUPPORTED: {name: "NOT_SUPPORTED", title: "Not supported"},
};

const EXPOSURE_ACTIVITIES = {
    IDLE: {name: "IDLE", title: "Idle"},
    QUEUED: {name: "QUEUED", title: "Queued"},
    RUNNING: {name: "RUNNING", title: "Running"},
};

const EXPOSURE_STATUSES = {
    UNKNOWN: {name: "UNKNOWN", title: "Unevaluated"},
    PENDING: {name: "PENDING", title: "Pending"},
    QUEUED: {name: "QUEUED", title: "Queued"},
    RUNNING: {name: "RUNNING", title: "Running"},
    CURRENT: {name: "CURRENT", title: "Current"},
    STALE: {name: "STALE", title: "Stale"},
    ERROR: {name: "ERROR", title: "Failed"},
    NOT_SUPPORTED: {name: "NOT_SUPPORTED", title: "Not supported"},
};

module.exports = {
    EXPOSURE_STATUSES,
    EXPOSURE_ACTIVITIES,
    EXPOSURE_DISPLAY_STATUSES,
    DEVICE_CAPTURE_STATUSES,
    DEVICE_DISCOVERY_STATUSES,
    AUDIT_STATUSES,
    DEVICE_CUSTOM_FIELDS,
    DEVICE_MANAGEMENT_STATES,
    LICENSE_STATUS,
    ACCESS_STATUS,
    DISCOVERY_LEVELS,
    DEVICE_ENVIRONMENTS,
    SOLUTION_DEFAULT_SHOWN_COLUMNS,
    LICENSE_RESTRICTED_COLUMNS,
    SOLUTION_DEFAULT_SHOWN_COLUMNS_IOT,
};
